/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import {Redirect, Switch, Route, useHistory} from "react-router-dom";
import {shallowEqual, useSelector} from "react-redux";
import {ContentRoute, Layout} from "../_metronic/layout";
import BasePage from "./BasePage";
import {Logout, AuthPage} from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import {FirstPasswordUpdate} from "./modules/Auth/pages/FirstPasswordUpdate";
import UnauthenticatedNewFichePage from "./pages/Fiches/UnauthenticatedNewFichePage/UnauthenticatedNewFichePage";
import IndexPage from "./pages/Unauthenticated/IndexPage/IndexPage";
import FicheDetailsPage from "./pages/Unauthenticated/FicheDetails/FicheDetailsPage";
import EmailValidationPage from "./pages/Unauthenticated/EmailValidation/EmailValidationPage";
import FicheRecapitulatifPage from "./pages/Unauthenticated/FicheRecapitulatif/FicheRecapitulatifPage";
import FicheListPage from "./pages/Fiches/FicheListPages/FicheListPage";
import FicheSearchPage from "./pages/Unauthenticated/FicheSearch/FicheSearchPage";
import AutoVerifyEmail from "./pages/Unauthenticated/AutoVerifyEmail/AutoVerifyEmail";
import {usePageView} from "./hooks/usePageView";

export function Routes() {
    const {isAuthorized, shouldUpdatePassword,shouldValidateEmail} = useSelector(
        ({auth}) => {

            console.log('user model',auth.user)

            return {
                isAuthorized: auth.user != null,
                shouldUpdatePassword: !!auth.user && auth.user.should_update_password,
                shouldValidateEmail: auth.user && !auth.user.email_verified_at
            }
        },
        shallowEqual
    );

    usePageView()

    return (
        <Switch>

            <Route path="/auth/email/auto-verify/:code" exact={true} component={AutoVerifyEmail}/>

            {!isAuthorized ? (
                /*Render auth page when user at `/auth` and not authorized.*/
                <Switch>

                    <Route path="/fiches/details/:code" exact={true} component={FicheDetailsPage}/>
                    <Route path="/fiches/search" component={FicheSearchPage}/>
                    <Route path="/fiches/email/validation/:formCode" exact={true} component={EmailValidationPage}/>
                    <Route path="/auth/email/auto-verify/:code" exact={true} component={AutoVerifyEmail}/>

                    <AuthPage/>
                </Switch>
            ) : (
                /*Otherwise redirect to root page (`/`)*/
                <Redirect from="/auth" to="/"/>
            )}

            <Route path="/error" component={ErrorsPage}/>
            <Route path="/logout" component={Logout}/>


            {
                shouldValidateEmail && (
                    <Route component={EmailValidationPage} />
                )
            }
            {/*<EmailValidationPage />*/}

            {!isAuthorized ? <Redirect to="/auth/login"/> :
                (shouldUpdatePassword ? (
                    <FirstPasswordUpdate/>
                ) : (
                    <Layout>
                        <BasePage/>
                    </Layout>
                )
                )}

            {/*{!isAuthorized ? (*/}
            {/*    /*Redirect to `/auth` when user is not authorized*/}
            {/*    <Redirect to="/auth/login"/>*/}
            {/*) : (*/}
            {/*    <Layout>*/}
            {/*        <BasePage/>*/}
            {/*    </Layout>*/}
            {/*)}*/}
        </Switch>
    );
}
